/**
 * @generated SignedSource<<36f1db6d060cea6f211e37b2593c0061>>
 * @relayHash e0b6de99bd438fb8c8ae87b89ca3f985
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f538dbd6a9864bd44b23a5427148c9b015e04b0f8771f3e0f865ecb346677761

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type team_teamSearchRefetchQueryNew$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
  organisationId: string;
  searchBy?: string | null | undefined;
  sessionId: string;
  siteId: string;
};
export type team_teamSearchRefetchQueryNew$data = {
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamEditviewFull_TeamEditViewWithFieldOptionsFragmentNew_fieldOptionsFragmentRef">;
};
export type team_teamSearchRefetchQueryNew = {
  response: team_teamSearchRefetchQueryNew$data;
  variables: team_teamSearchRefetchQueryNew$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organisationId"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "searchBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v5 = {
  "kind": "Variable",
  "name": "searchBy",
  "variableName": "searchBy"
},
v6 = {
  "kind": "Variable",
  "name": "sessionId",
  "variableName": "sessionId"
},
v7 = {
  "kind": "Variable",
  "name": "siteId",
  "variableName": "siteId"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "team_teamSearchRefetchQueryNew",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "team_issueFieldTeamEditviewFull_TeamEditViewWithFieldOptionsFragmentNew_fieldOptionsFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "team_teamSearchRefetchQueryNew",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraTeamViewConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraTeamViewEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "jiraSuppliedId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "jiraMemberCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "jiraIncludesYou"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "jiraSuppliedIsVerified"
                          },
                          {
                            "args": [
                              (v7/*: any*/)
                            ],
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "fullTeam",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": "name",
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "alias": "avatarUrl",
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              }
                            ]
                          },
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v9/*: any*/),
                "filters": [
                  "searchBy",
                  "organisationId",
                  "sessionId"
                ],
                "handle": "connection",
                "key": "team_issueFieldTeamEditviewFullNew_teams",
                "kind": "LinkedHandle",
                "name": "teams"
              }
            ],
            "type": "JiraTeamViewField"
          },
          (v10/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "f538dbd6a9864bd44b23a5427148c9b015e04b0f8771f3e0f865ecb346677761",
    "metadata": {},
    "name": "team_teamSearchRefetchQueryNew",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "91d85c959f6d4d81b77c2c8802e4c03f";

export default node;
